import React, { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
// import conxtdOut from 'apis/conxtdOut';
// import ReactTableWrapper from './ReactTableWrapper';
import { Tooltip } from 'components/Common/Tooltip/Tooltip';
import Icon from 'components/Icons/Icon';
import { Modal, Row, Col} from 'react-bootstrap';

import CustomProgressBar from '../CustomProgressBar';

import Axios from '../../../../../../node_modules/axios/index';

import { useIsMounted } from 'components/Common/CustomHooks/useIsMounted';

import './LogViewPage.scss'
import TimezoneDate from 'components/Common/TimezoneDate';
import DataTableWrapper from './DataTableWrapper';
import { loadCompanyAssetLogViewStart, resetCompanyAssetLogView } from 'services/redux/actions/serviceDesk';
import Loading from 'components/Loading';

function LogViewPage({ uid, show, hideModal, setViewUid, status, percentage, triggerCall, handleStorePaginationState, dataTableState }) {

  const dispatch = useDispatch();

  const darkMode = useSelector(state => state.user.darkMode);
  const timezone = useSelector(state => state.user.timezone);
  const logViewData = useSelector(state => state.serviceDesk.assets.companyAssetLogView.data?.logViewData) ?? []
  const pagination = useSelector(state => state.serviceDesk.assets.companyAssetLogView?.data?.pagination) ?? {}
  const loadingLogData = useSelector(state => state.serviceDesk.assets.companyAssetLogView.loadingCompanyAssetLogView)
  const initialiseLog = useSelector(state => state.serviceDesk.assets.companyAssetLogView.initialiseLog)

  const [logData, setLogData] = useState([]);

  useEffect(() => {
    if (Array.isArray(logViewData) && logViewData.length > 0) {
      setLogData(logViewData);
    }
  }, [logViewData])

  const getLogView = useCallback(() => {
    const source = Axios.CancelToken.source();

    if (uid) {

      initialiseLog && setLogData([]);

      if (triggerCall && status?.code === "N") {
        const {pageSize, requestNumber} = dataTableState;

        dispatch(loadCompanyAssetLogViewStart({
          uid,
          limit: pageSize,
          page: requestNumber,
          pageSize: pageSize,
        }));
      }
    }

    return () => {
      source.cancel("Component unmounted: request cancelled");
    }
  }, [uid, triggerCall, initialiseLog, logViewData, logData, pagination, JSON.stringify(dataTableState)])

  useEffect(() => {
    getLogView();
  }, [uid, triggerCall, initialiseLog])
  
  useEffect(() => {
    
    return () => {
      setViewUid(null);
    }
  }, [])

  const columnHeaders = [
    {
      key: "TIMESTAMP",
      Header: "Timestamp",
      id: "created",
      minWidth: 150,
      filterable: false,
      accessor: data => {
        const created = {
          acked: data.created,
          timezone: data.timezone,
          format: "HH:mm ddd DD/MM/YYYY",
        }
        return created;
      },
      Cell: ({ row }) => {
        const occurrence = row.created;
        return (
          <TimezoneDate
            date={occurrence.acked}
            timezone={timezone} 
            format={occurrence.format} 
            hideTimezone={true}
          />
        )
      },
    },
    {
      key: "Message",
      Header: "Message",
      id: "message",
      filterable: false,
      width: 550,
      accessor: data => {
        const message = data?.message;
        return (
          message &&
            <span className='data-table-cell'>{message}</span>
        )
      },
      Cell: ({row}) => {
        const message = row?.message?.props?.children;
        const error = row?._original?.error
        return (
          <div className={`rt-td ${error ? "bg-danger" : "bg-success"}`}>
            {message}
          </div>
        )
      },
    },
  ];

  return (
    <>
      {uid &&
        <Modal
        id='log-view-page-modal'
        backdrop='static'
        centered
        keyboard={false}
        onHide={() => {
          hideModal();
          setTimeout(() => {
            setLogData([]);
            dispatch(resetCompanyAssetLogView());
          }, 500)
        }}
        show={show}
        size='lg'
      >
        <Modal.Header
          closeButton
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <Modal.Title className='w-100'>
            <Row className='d-flex justify-content-between align-items-center'>
              <Col xs={6} sm={6} md={6} lg={6} id='log-page-header-text'>
                <div className='d-flex align-items-center flex-row flex-nowrap'>
                  <div>
                    <span className='mr-1'>Log:</span>
                    <span>{uid}</span>
                  </div>
                  {/* {initialiseLog && loadingLogData ? <Loading className='ml-1' /> : <></>} */}
                </div>
              </Col>
              <Col xs={6} sm={6} md={6} lg={6} className='w-100'>
                {status?.code === "N" ?
                  <CustomProgressBar show={true} value={percentage ?? 0} styling="modal-title-width" tooltip={true} />
                :
                  <span className='d-flex justify-content-end align-items-center'>
                    <Tooltip
                      placement='top'
                      description={status?.icon?.description}
                      white={!darkMode}
                    >
                      {status?.icon.icon && <Icon className={`fas fa-${status?.icon.icon}`} style={{ color: status?.icon.colour }} />}
                    </Tooltip>
                  </span>
                }
              </Col>
            </Row>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          className={`${darkMode ? 'darkMode' : 'background-modal-wrapper'}`}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >

        {/* Table */}
        {uid && 
          <DataTableWrapper
            id="log-view-data-table"
            columns={columnHeaders}
            data={logData}
            pages={pagination && pagination.pageCount}
            loadDataAction={loadCompanyAssetLogViewStart}
            loadDataParams={{uid, pagination}}
            defaultPageSize={10}
            noDataText={(initialiseLog && Array.isArray(logData) && logData.length <= 0) ? 
              <div className='d-flex flex-nowrap flex-row align-items-center'>
                <span>Initialising...</span>
                <Loading className='ml-1' />
              </div>
                :
              "No log messages have been found"
            }
            handler={handleStorePaginationState}
          />
        }

        </Modal.Body>
      </Modal>}
    </>
  )
}

export default LogViewPage;